import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { EmailVerificationBadge } from '../../../../components/EmailVerificationBadge'
import { StatusPill } from '../../../../components/StatusPill'
import { getOrgRoleLabel, type OrgMember, OrgRole } from '../../../../models/user'

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-0.5">
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div className="text-sm">{value || <span className="text-muted-foreground">—</span>}</div>
    </div>
  )
}

export function UserDetailsDialog({
  member,
  open,
  onOpenChange,
}: {
  member: OrgMember
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const fullName = [member.firstName, member.middleName, member.lastName].filter(Boolean).join(' ')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>{fullName || member.email}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4">
          <Row label="First name" value={member.firstName} />
          <Row label="Last name" value={member.lastName} />
          <Row label="Middle name" value={member.middleName} />
          <Row
            label="Email"
            value={
              <span className="flex items-center gap-2">
                {member.email}
                <EmailVerificationBadge status={member.emailVerification} />
              </span>
            }
          />
          <Row label="Phone" value={member.mobile} />
          <Row label="Date of birth" value={member.dob} />
          <Row label="Role" value={getOrgRoleLabel(member.orgUser.role as OrgRole)} />
          <Row label="Status" value={<StatusPill status={member.orgUser.status} />} />
          <Row label="User ID" value={<span className="font-mono text-xs">{member.id}</span>} />
          <Row label="Created" value={new Date(member.dateCreated).toLocaleString()} />
          <Row label="Updated" value={new Date(member.dateUpdated).toLocaleString()} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
